import { useEffect, useState, useRef } from 'react'
import AnimText from './HomeAnimText'
import Button from './HomeButton'
import Logo from '../../components/Logo'
import Arrow from '../../components/Arrow'
import { getColors } from '../../helpers/layoutHelper'

const Words = ({ words, theme }) => {
  const loaded = useRef(false)
  const [active, setActive] = useState(false)
  const [wordIndex, setWordIndex] = useState(0)

  useEffect(() => {
    const animInTime = 300
    const animOutTime = 1800
    let animOutTimer
    if (loaded.current) {
      animOutTimer = setTimeout(() => setActive(false), animOutTime)
    }
    const animInTimer = setTimeout(
      () => {
        const newWordIndex = wordIndex > words.length - 2 ? 0 : wordIndex + 1
        setWordIndex(newWordIndex)
        setActive(true)
      },
      loaded.current ? animOutTime + animInTime : 2100
    )
    loaded.current = true
    return () => {
      clearTimeout(animOutTimer)
      clearTimeout(animInTimer)
    }
  }, [wordIndex, words.length])

  return (
    <span
      className={active ? 'word active' : 'word'}
      style={{
        color: 'transparent',
        background: `linear-gradient(45deg, ${theme.primary}, ${theme.secondary})`,
        WebkitBackgroundClip: 'text'
      }}
    >
      {words[wordIndex]}
    </span>
  )
}

const Intro = ({ theme, onPress }) => {
  return (
    <>
      <h1>
        <AnimText delay={600}>{'We help people turn '}</AnimText>
        <span className='ideas'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 164 72'
            style={{ fill: theme.text }}
          >
            <path d='M.31,62a5.75,5.75,0,0,1,.55-2.62A4.82,4.82,0,0,1,1.08,58a5.19,5.19,0,0,0,.22-1,11.32,11.32,0,0,1,.87-3.59A139.88,139.88,0,0,0,7.4,38.08a1.18,1.18,0,0,1,.44-.93,2.44,2.44,0,0,1,1.31-.49,6.46,6.46,0,0,1,1.2-.22,1.55,1.55,0,0,1,1.14.49,13.68,13.68,0,0,1,1.37,1.8,2.69,2.69,0,0,1,.65,2,11.94,11.94,0,0,1-1.42,5,25.62,25.62,0,0,0-1.85,5.46,46.56,46.56,0,0,0-2.07,5.45q-.23.65-.66,2.61a9.91,9.91,0,0,1-1.2,3.17,22.59,22.59,0,0,1-1.2,4.25q-.54,1.2-1.2,1.2T1.84,66.32A5.88,5.88,0,0,1,.31,62Zm10.8-42.53q-.54-1.86,0-1.86c.58-.07,1.26-.7,2-1.91a5,5,0,0,0,1-3,1.2,1.2,0,0,1,.33-.81,1.4,1.4,0,0,1,.77-.49,3,3,0,0,1,1.52-.55c1.24,0,2.36.87,3.38,2.62a6.09,6.09,0,0,1,.66,2.51,4.21,4.21,0,0,1-.55,2,14.79,14.79,0,0,1-2,2.67q-1.86,2.52-3.49,2.52a3.9,3.9,0,0,1-2.4-1.1A6.11,6.11,0,0,1,11.11,19.43ZM41.36,69.49a26.26,26.26,0,0,1-1.53-8.95,11.06,11.06,0,0,1,.11-1.85l.22-2.29L35.9,59.78A27.6,27.6,0,0,1,29,64.36a15.58,15.58,0,0,1-6.27,1.53,8.47,8.47,0,0,1-3.55-1.58,7.45,7.45,0,0,1-2.45-3,6.13,6.13,0,0,1-.44-2.62,26.68,26.68,0,0,1,2.18-9.54A29.76,29.76,0,0,1,23.91,40Q28.59,32.95,34.38,33a10.46,10.46,0,0,1,5.45,1.64A17.62,17.62,0,0,0,43,35.68a1,1,0,0,0,1-.55,7.3,7.3,0,0,0,.66-2q1.2-5,2.29-8.4,2.4-7.2,4.14-11.56c1.17-2.91,2.58-6.11,4.26-9.6a9.82,9.82,0,0,1,1.91-3A2.24,2.24,0,0,1,59,0c1.59,0,2.83,1.08,3.7,3.27a3.83,3.83,0,0,1,.33,1.52,5.19,5.19,0,0,1-.65,2.08,113.81,113.81,0,0,0-7,16Q51.27,34,49,42.22A69.8,69.8,0,0,0,47.3,52.58a112.15,112.15,0,0,0-.71,11.24,12.66,12.66,0,0,0,.22,2.83,11.93,11.93,0,0,1,.54,3.27,1.72,1.72,0,0,1-.54,1.48,3.85,3.85,0,0,1-1.74.49Q42.34,72.54,41.36,69.49Zm-8.62-13c.44-.29,1.49-1,3.16-2.29a14.68,14.68,0,0,0,3.82-3.93,14,14,0,0,0,1.85-4.69,7.6,7.6,0,0,0-.38-3.22,6.29,6.29,0,0,0-1.91-2.45,4.6,4.6,0,0,0-2.72-.76,7.76,7.76,0,0,0-5.45,2.4,25,25,0,0,0-5.24,6.76,35.42,35.42,0,0,0-3.49,9.59c-.22,1.39.51,2.08,2.18,2.08a7.63,7.63,0,0,0,2.07-.22A17,17,0,0,0,32.74,56.51ZM57.53,66.65a12.8,12.8,0,0,1-3.05-8.73,33,33,0,0,1,2.35-11.5,46,46,0,0,1,6.05-11.29q3.7-5,7.52-6.76a10,10,0,0,1,4.91-1.2A11.44,11.44,0,0,1,80,28.37a7.82,7.82,0,0,1,2.84,1.85,9.85,9.85,0,0,1,1.74,3.38,19.59,19.59,0,0,1,.33,2.73,15.24,15.24,0,0,1-.55,2.84A22.41,22.41,0,0,1,80.93,46a18.57,18.57,0,0,1-5.51,4.75,8.15,8.15,0,0,1-4.36,1.09A11.25,11.25,0,0,1,66.75,51a6.55,6.55,0,0,1-3.11-2.45l-.76-.88-.33.88a28.51,28.51,0,0,0-2.29,10,8.51,8.51,0,0,0,1.09,4.58c.51.8,1.75,1.2,3.71,1.2a8.15,8.15,0,0,0,3.16-.44,12.07,12.07,0,0,0,2.89-1.36c.84-.54,1.66-1.11,2.46-1.69l.43-.22h-.11a23.81,23.81,0,0,0,2.19-1.2c.58-.36,1-.61,1.19-.76a1,1,0,0,0,.44-.11,1.26,1.26,0,0,0,.44-.43,2.43,2.43,0,0,1,2.29.32,2.26,2.26,0,0,1,1.31,2,8.9,8.9,0,0,1-2,2.83q-1.74,2-2.61,2.07a3.35,3.35,0,0,0-.77.33,4,4,0,0,0-.87.54h.11a2.63,2.63,0,0,1-2,1.31H72.8c-.29.58-1.25,1.17-2.89,1.75a13.85,13.85,0,0,1-4.63.87A9.84,9.84,0,0,1,57.53,66.65ZM76.18,42.44a11.55,11.55,0,0,0,2.62-7A3.63,3.63,0,0,0,78,32.84a2.72,2.72,0,0,0-1.2-.33,8.92,8.92,0,0,0-1.86.33c-.94.22-2.4,1.22-4.36,3a28.53,28.53,0,0,0-4.36,4.75l-1.42,2.29a6.05,6.05,0,0,1,1.69-.39c.55,0,.86,0,.93.17a4,4,0,0,0,.76,2.51,2.39,2.39,0,0,0,2,1Q73.46,46.15,76.18,42.44ZM88.22,65a6.26,6.26,0,0,1-2.73-3.6A6.71,6.71,0,0,1,85.38,60q0-4,3.11-10.42A58.77,58.77,0,0,1,96.07,37.8q4.47-5.4,8.18-6.81a9.41,9.41,0,0,1,2.94-1.2,9.33,9.33,0,0,1,3,1.2,7.72,7.72,0,0,1,2.29,1,10.46,10.46,0,0,1,2,2.18,23.71,23.71,0,0,1,2.07,7,13.82,13.82,0,0,1,.66,3.27,2.1,2.1,0,0,1-.66,1.53l-.38.43a1,1,0,0,0-.27.5c0,.11.07.16.22.16a2.68,2.68,0,0,1-.11.49,6.12,6.12,0,0,1-.44,1,24.24,24.24,0,0,0-1.31,7.08,11.07,11.07,0,0,0,.22,2.08,3.82,3.82,0,0,0,3.71,2.83,5.81,5.81,0,0,0,4.14-2c1.17-.8,2-1.36,2.57-1.69s.82-.24.82.27a2.15,2.15,0,0,0,.43.33,1.16,1.16,0,0,0,.66.22c.5,0,.76.32.76,1a4.24,4.24,0,0,1-.76,2.18,17.08,17.08,0,0,0-1.2,1.31,1.6,1.6,0,0,0-.44.87l-1.64,1.53a9.59,9.59,0,0,1-4.9,1.2,8.13,8.13,0,0,1-4.69-1.2,14.73,14.73,0,0,1-4.8-6.87l-.55-1.09-3.16,2.07a32.3,32.3,0,0,1-2.51,2.23c-.94.77-1.56,1.3-1.85,1.59-.58.73-1.09,1.09-1.53,1.09H98.36c0,.51-.71,1.07-2.13,1.69a9.52,9.52,0,0,1-3.76.92A5.26,5.26,0,0,1,88.22,65Zm9.27-8.13a34.36,34.36,0,0,0,6.21-5.07l3.17-3.27a15.7,15.7,0,0,0,2.78-4.48,12.07,12.07,0,0,0,1-4.58,4.7,4.7,0,0,0-.54-2.61c-.29-.87-.73-1.31-1.31-1.31a11.81,11.81,0,0,0-2.51.76c-1.38.87-3.32,2.88-5.83,6A84,84,0,0,0,93.78,52q-2.94,5-2.94,7.25a1.22,1.22,0,0,0,.21.66,3.33,3.33,0,0,0,.33.43Q92.58,60.32,97.49,56.89Zm35.22,10.53a7.4,7.4,0,0,1-3.6-4.15,15.3,15.3,0,0,1-.76-2.18,1,1,0,0,1,.76-1,3.48,3.48,0,0,1,1.8.65,8,8,0,0,0,1.69.87,6.29,6.29,0,0,0,4.48,1.53,9,9,0,0,0,4-.87q1.8-.87,2-2.07A22.23,22.23,0,0,0,142,56.4a35.27,35.27,0,0,1-4.2-8,21.13,21.13,0,0,1-1.47-6.92,8.84,8.84,0,0,1,1.2-4.26,11.47,11.47,0,0,1,3.27-3.71,31.1,31.1,0,0,1,6.6-5.12,29.38,29.38,0,0,1,7-3.16,20.33,20.33,0,0,1,3.21.32,9.07,9.07,0,0,1,2.68.77,4.93,4.93,0,0,1,2.29,2.4,7.74,7.74,0,0,1,1.09,3.71,10.28,10.28,0,0,1-1.86,4.79,12.38,12.38,0,0,1-.87,2.08,5.49,5.49,0,0,0-.65,1.63A1.49,1.49,0,0,1,158.89,42a2.71,2.71,0,0,1-1.91-.93,6.67,6.67,0,0,1-1.47-2.23,9.55,9.55,0,0,1-.33-2.29,4.71,4.71,0,0,1,.87-2.62c.8-.8,1.2-1.34,1.2-1.63s-.4-.44-1.2-.44-2.54.69-5,2.07a24.42,24.42,0,0,0-5.89,4.37,11.68,11.68,0,0,0-2.4,2.77,6.86,6.86,0,0,0-.44,2.79,13.19,13.19,0,0,0,.71,3.87,7.76,7.76,0,0,0,1.47,3c.15.29.45.91.93,1.85a16.91,16.91,0,0,0,1.69,2.73c1.45,3.27,2.18,5.82,2.18,7.63a4.89,4.89,0,0,1-2.45,4.58q-2.46,1.42-7.69,1.42A13,13,0,0,1,132.71,67.42Z' />
          </svg>
        </span>
        <AnimText delay={1500}>{' into '}</AnimText>
        <br />
        <Words
          words={[
            'remarkable',
            'exceptional',
            'emotive',
            'disruptive',
            'daring',
            'delightful',
            'wonderful',
            'extraordinary',
            'award-winning'
          ]}
          theme={theme}
        />
        <AnimText delay={1800}>{' digital products.'}</AnimText>
      </h1>
      <Arrow onClick={onPress} color={theme.primary} delay={2300} />
    </>
  )
}

const Partners = ({ theme, onPress }) => {
  const logos = [
    'spotify',
    'napster',
    'google',
    'canonical',
    'barclays',
    'melodyvr',
    'goeuro',
    'sportpursuit'
  ]
  const logoColors = getColors(logos.length, [theme.primary, theme.secondary])
  return (
    <>
      <h2>
        <AnimText>{`We've worked with:`}</AnimText>
      </h2>
      <div className='partners'>
        {logos.map((logo, index) => (
          <Logo
            key={index}
            name={logo}
            style={{
              fill: logoColors[index],
              animationDelay: `${300 + index * 50}ms`
            }}
          />
        ))}
      </div>
      <Arrow onClick={onPress} color={theme.primary} delay={1200} />
    </>
  )
}

const Contact = ({ theme, onPress }) => {
  const [wordActive, setWordActive] = useState(false)

  useEffect(() => {
    const timeoutTest = setTimeout(() => {
      setWordActive(true)
    }, 645)
    return () => clearTimeout(timeoutTest)
  }, [])

  return (
    <>
      <h1>
        <AnimText>{`We'd love to share our work`}</AnimText>
        <AnimText delay={420}>{` and chat more `}</AnimText>
        <span
          className={wordActive ? 'word active' : 'word'}
          style={{
            color: 'transparent',
            background: `linear-gradient(45deg, ${theme.primary}, ${theme.secondary})`,
            WebkitBackgroundClip: 'text'
          }}
        >
          {'with you'}
        </span>
        <AnimText delay={765}>{`.`}</AnimText>
      </h1>
      <Button
        onPress={onPress}
        text='Get in touch'
        theme={theme}
        style={{ animationDelay: '1200ms' }}
      />
    </>
  )
}

const Content = ({ index, theme, onPress }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [transitioning, setTransitioning] = useState(false)

  useEffect(() => {
    setTransitioning(true)
    const timeout = setTimeout(() => {
      setCurrentIndex(index)
      setTransitioning(false)
    }, 150)
    return () => clearTimeout(timeout)
  }, [index])

  return (
    <div
      className={transitioning ? 'content' : 'content active'}
      style={{
        color: theme.text
      }}
    >
      {currentIndex === 0 && <Intro theme={theme} onPress={onPress} />}
      {currentIndex === 1 && <Partners theme={theme} onPress={onPress} />}
      {currentIndex === 2 && <Contact theme={theme} onPress={onPress} />}
    </div>
  )
}

export default Content
